import { cva, VariantProps } from "class-variance-authority";

export const textVariants = cva(null, {
  variants: {
    variant: {
      title: "text-3xl leading-[1.875] font-semibold tracking-[0.4px]",
      headerOne: "text-2xl leading-8 font-semibold tracking-[0.4px]",
      headerTwo: "text-xl leading-7 font-semibold tracking-normal",
      headerThree: "text-lg leading-[1.125] font-medium tracking-normal",
      lg: "text-base leading-6 tracking-normal",
      md: "text-sm leading-5 tracking-normal",
      sm: "text-xs leading-4 tracking-normal",
    },
    weight: {
      regular: null,
      medium: null,
      bold: null,
    },
  },
  compoundVariants: [
    {
      variant: ["lg", "md", "sm"],
      weight: "regular",
      className: "font-normal",
    },
    {
      variant: ["lg", "md", "sm"],
      weight: "medium",
      className: "font-medium",
    },
    {
      variant: ["lg", "md", "sm"],
      weight: "bold",
      className: "font-semibold",
    },
  ],
  defaultVariants: {
    weight: "regular",
    variant: "md",
  },
});

export type TextVariantType = NonNullable<
  VariantProps<typeof textVariants>["variant"]
>;

export type TextWeightType = NonNullable<
  VariantProps<typeof textVariants>["weight"]
>;
